<template>
  <PagedSearchResult />
</template>

<script>
import PagedSearchResult from './page/_page'
export default {
  components: {
    PagedSearchResult,
  },
}
</script>
